
import { IFetchLeadsByOriginIdProtocol } from '@/domain/application/protocols/leads/IFetchLeadsByOriginIdProtocol'
import { ILeadsRepository } from '@/domain/application/repositories/ILeadsRepository'
import { FetchLeadsByOriginIdUseCase } from '@/domain/application/useCases/leads/fetchLeadsByOriginId'
import { prismaService } from '@/infra/database/prisma'
import { PrismaLeadsRepository } from '@/infra/database/prisma/repositories/prismaLeadsRepository'
import { Request, Response } from 'express'
import { LeadPresenter } from '../presenters/leadPresenter'
import { z } from 'zod'

const createUserBodySchema = z.object({
  originId: z.string(),
})

export class FetchManyLeadsByOriginController {
  private repository: ILeadsRepository = new PrismaLeadsRepository(prismaService)
  private useCase: IFetchLeadsByOriginIdProtocol = new FetchLeadsByOriginIdUseCase(
    this.repository,
  )

  async handle(request: Request, response: Response) {
    try {
      const { originId } = createUserBodySchema.parse(request.params)
      const {leads} = await this.useCase.execute({originId})
      return response.status(200).send({
        leads: leads.map(LeadPresenter.toHttp)
      })
    } catch (error) {
      if(error instanceof Error) {
        return response.status(400).send({
          message: error.message,
        })
      }
    }
  }
}